import React, { useEffect } from 'react';
import classNames from 'classnames';

interface iSeeMoreCollapsibleProps {
  children: React.ReactNode;
  cutoffHeightPx?: number;
}

export const SeeMoreCollapsible = (props: iSeeMoreCollapsibleProps) => {
  const { children, cutoffHeightPx: cutoffHeight = 100 } = props;
  const [originalHeight, setOriginalHeight] = React.useState(0);
  const [isOpen, setIsOpen] = React.useState(false);
  const [needsSeeMore, setNeedsSeeMore] = React.useState(false);
  const childrenRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const height = childrenRef.current?.getBoundingClientRect().height || 0;
    setOriginalHeight(height);
    if (height >= cutoffHeight) {
      setNeedsSeeMore(true);
    } else {
      setNeedsSeeMore(false);
    }
    // `isOpen` so that it re-calculates everytime it opens/closes, to account for if the user
    // has changed the width of the browser or something after the page loads
  }, [isOpen, childrenRef]);

  return (
    <>
      <div
        style={{
          height: '100%',
          maxHeight: needsSeeMore && !isOpen ? `${cutoffHeight}px` : `${originalHeight}px`,
        }}
        className={classNames('relative overflow-y-clip transition-[max-height]', {})}
      >
        <span ref={childrenRef}>{children}</span>
        <div
          className={classNames('absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent', {
            block: needsSeeMore && !isOpen,
            hidden: (needsSeeMore && isOpen) || !needsSeeMore,
          })}
        ></div>
      </div>

      {needsSeeMore && (
        <button
          className="bg-none p-0 bg-transparent text-brown-prime underline cursor-pointer"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          {isOpen ? 'See less' : 'See more'}
        </button>
      )}
    </>
  );
};
